import React from 'react';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import styles from './project-quote.module.css';
import ReactFitText from 'react-fittext';

const ProjectQuote = props => {
  return (
    <Reveal>
      <RevealSlideDown isInView={props.isInView}>
        <ProjectQuoteContent {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

const ProjectQuoteDash = props => {
  const animationConfig = {
    delay: 500,
    duration: 900,
    easing: easings.easeCubicOut,
  };
  const { isInView } = props;
  return (
    <Spring
      from={{ bottom: '100%' }}
      to={{
        bottom: isInView ? '0%' : '100%',
      }}
      config={animationConfig}
    >
      {animationDash => (
        <span
          className={styles.dash}
          style={{ bottom: animationDash.bottom }}
        />
      )}
    </Spring>
  );
};

const ProjectQuoteContent = props => {
  const { quote, name, title, animation, isInView } = props;
  return (
    <div className={styles.wrapper} style={animation}>
      <div className={styles.content}>
        <ProjectQuoteDash {...props} />
        <ReactFitText compressor={2} maxFontSize={35}>
          <h3 className={styles.copy}>
            {quote}
            <span className={styles.endQuote}>"</span>
          </h3>
        </ReactFitText>
        <div className={styles.info}>
          <h5 className={styles.name}>{name}</h5>
          <h5 className={styles.title}>{title}</h5>
        </div>
      </div>
    </div>
  );
};

export default ProjectQuote;



// WEBPACK FOOTER //
// ./src/components/project/project-quote/index.js